<template>
  <b-modal ref="newProjectDialog" title="New Project" size="lg" @show="reset">
    <b-tabs>
      <b-tab title="Social Network Templates">
        <div class="template-select">
          <div
            v-for="(socialTemplates, socialName) in templates"
            :key="socialName"
          >
            <h2>{{ socialName }}</h2>
            <b-row align-h="start">
              <b-col
                md="4"
                cols="6"
                v-for="template in socialTemplates"
                :key="template.id"
              >
                <b-card
                  no-body
                  class="text-center border shadow-sm"
                  :class="{ selected: selectedTemplate == template.id }"
                  @click="setTemplateOptions(template)"
                >
                  <img
                    :src="'/img/templates/' + template.thumbnail"
                    class="card-img-top"
                  />
                  <b-card-body>
                    <b-card-title>{{ template.name }}</b-card-title>
                    <b-card-sub-title>
                      {{ template.width }}x{{ template.height }}
                    </b-card-sub-title>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-tab>
      <b-tab title="Custom">
        <b-row align-v="center" class="mb-3 mt-3">
          <b-col cols="3" sm="2">
            <label>Width:</label>
          </b-col>
          <b-col cols="9" sm="2">
            <b-input
              v-model="canvasWidth"
              type="number"
              placeholder="auto"
            ></b-input>
          </b-col>
          <b-col cols="3" sm="auto">
            <label>Height:</label>
          </b-col>
          <b-col cols="9" sm="2">
            <b-input
              v-model="canvasHeight"
              type="number"
              placeholder="auto"
            ></b-input>
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>

    <b-row align-v="center" class="mb-3">
      <b-col cols="12" sm="2">
        <label>Project Name:</label>
      </b-col>
      <b-col class="text-right">
        <b-form ref="form">
          <b-input-group :class="{ 'is-invalid': nameState === 'invalid' }">
            <b-input
              v-model="projectName"
              type="text"
              @keyup="checkFormValidity"
              @blur="checkFormValidity"
              required
            ></b-input>
            <b-input-group-append>
              <multiselect
                v-model="fileTypeSelected"
                :multiple="false"
                :options="fileTypes"
                :show-labels="false"
                :show-pointer="false"
              ></multiselect>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <div slot="modal-footer" class="w-100">
      <b-row>
        <b-col>
          <b-button block variant="secondary" @click="closeDialog">
            Cancel
          </b-button>
        </b-col>
        <b-col>
          <b-button block variant="primary" @click="emmitCreateEvent">
            Create
          </b-button>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import { CANVAS_TEMPLATES } from "@/constants.js";

export default {
  name: "NewProjectDialog",
  data() {
    return {
      projectName: "",
      projectFileType: "",
      canvasWidth: "",
      canvasHeight: "",
      fileTypes: ["jpeg", "png", "svg"],
      fileTypeSelected: "jpeg",
      templates: CANVAS_TEMPLATES,
      selectedTemplate: "",
      nameState: "valid"
    };
  },
  methods: {
    openDialog() {
      this.$refs.newProjectDialog.show();
    },
    closeDialog() {
      this.$refs.newProjectDialog.hide();
    },
    emmitCreateEvent() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return;
      }

      this.$emit("createdProject", {
        projectName: this.projectName,
        projectFileType: this.fileTypeSelected,
        canvasWidth: this.canvasWidth,
        canvasHeight: this.canvasHeight
      });
      this.closeDialog();
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.nameState = valid ? "valid" : "invalid";
      return valid;
    },
    setTemplateOptions(template) {
      this.canvasWidth = template.width;
      this.canvasHeight = template.height;
      this.selectedTemplate = template.id;
      this.projectName = template.projectName;

      this.$nextTick(() => {
        this.checkFormValidity();
      });
    },
    reset() {
      this.selectedTemplate = "";
      this.fileTypeSelected = "jpeg";
      this.projectName = "";
      this.canvasWidth = "";
      this.canvasHeight = "";
    }
  },
  computed: {},
  components: {
    Multiselect
  }
};
</script>

<style scoped lang="scss">
.tabs {
  margin-top: -1.5rem;
}

.tab-pane,
.template-select {
  &:focus {
    outline: none;
  }
}

.template-select {
  padding: 1.5rem;
  background-color: #f3f3f3;
  border: 1px solid #e3ebf6;
  margin: 0 -1.5rem;
  margin-bottom: 1.5rem;
  height: 250px;
  overflow: auto;
}

@media (min-width: 1024px) {
  .template-select {
    height: 400px;
  }
}

.card {
  &:hover {
    cursor: pointer;
    box-shadow: 0 0.5rem 1rem rgba(18, 38, 63, 0.15) !important;
  }

  &.selected {
    background-color: #00d97e;
    color: white;

    .text-muted {
      color: white !important;
    }
  }
}
</style>

<style lang="scss">
.input-group-append .multiselect__tags {
  border: 1px solid #d2ddec;
  border-left: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  min-height: 41px;
}
</style>
